export default "__VITE_ASSET__CDPVmbWS__"